import { render } from "./PendingNotificationTable.vue?vue&type=template&id=2ac85e8a&ts=true"
import script from "./PendingNotificationTable.vue?vue&type=script&lang=ts"
export * from "./PendingNotificationTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__